// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AuctionActivityNounTitle_wrapper__2ia4b"};